module.exports = __webpack_public_path__ + "img/reset_code.fb2b0962.svg";